import {
  ChangeDetectionStrategy, Component, HostBinding, Input,
} from '@angular/core'

/**
 * Select IDs need to be unique across components, so this counter exists outside of
 * the component definition.
 */
let _uniqueIdCounter = 0
@Component({
  selector: 'kb-control-hint',
  templateUrl: './control-hint.component.html',
  styleUrls: ['./control-hint.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
})
export class ControlHintComponent {
  @Input() public showError?: boolean

  @HostBinding('id')
  public id = `kb-label-hint-${_uniqueIdCounter++}`
}
